// extracted by mini-css-extract-plugin
export var active = "gallery-miniature-module--active--vi2dE";
export var button = "gallery-miniature-module--button--U2COv";